// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"366":"7b74579e","496":"03c07316","647":"f9cada07","784":"b9230fd5","930":"76b9a353","960":"89a1496a"}[chunkId] + ".chunk.css";
};